module.exports = __webpack_public_path__ + "e7fb0dfc1a7ba25626b05ba502bb0e73.svg";